import { ASSERTION_TYPES } from "@constants/agentSim";

export const paramKindFor = (type) => {
  const found = ASSERTION_TYPES.find((a) => a.value === type);
  return found ? found.param : null;
};

export const defaultParamsFor = (type) => {
  const kind = paramKindFor(type);
  if (kind === "topics") return { topics: [] };
  if (kind === "topic") return { topic: "" };
  return {};
};

export const emptyAssertion = (type = "questions_collected") => ({
  type,
  params: defaultParamsFor(type),
  description: "",
});

export const changeAssertionType = (assertion, newType) => ({
  type: newType,
  params: defaultParamsFor(newType),
  description: assertion.description || "",
});
